module.exports = __webpack_public_path__ + "static/media/music.5b53ef0b.png";